import Loadable from "react-loadable";
import ErrorPage from "@src/pages/ErrorPage";
import LoadPage from "@src/pages/LoadPage";
import { delay } from "zq-ui-v3/utils/utils";
import { ErrorBoundary } from "@src/pages/ErrorBoundary";

export default ({ path, title, hasChild, items }) => {
  const pagePath = path;
  // 依据不同的url 加载不同的页面
  // if (path.startsWith("/docs/")) {
  //   pagePath = "/DocTemp";
  // }

  const Component: any = Loadable({
    loader: async () => {
      await delay(600);
      try {
        return await import(`@src/pages${pagePath}.tsx`);
      } catch (e: any) {
        console.warn(e?.stack);
        try {
          return await import(`@src/pages${pagePath}/index.tsx`);
        } catch (e: any) {
          console.warn(e?.stack);
          try {
            const commonPath = hasChild ? "/BaseDir.tsx" : "/BasePage.tsx";
            return await import(`@src/pages${commonPath}`);
          } catch (e: any) {
            console.warn(e?.stack);
            return ErrorPage;
          }
        }
      }
    }, // 关键的加载逻辑可以放在这里，这样就可以通过多个模板来进行页面的加载
    loading: (props) => {
      if (props.error) {
        return <ErrorPage />;
      } else if (props.pastDelay) {
        return <LoadPage />;
      } else {
        return null;
      }
    },
    delay: 100,
  });
  return (props) => {
    return (
      <ErrorBoundary>
        <Component {...props} title={title} path={path} items={items} />
      </ErrorBoundary>
    );
  };
};
